import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import { CustomerHelper } from "../../crm/helpers/customerHelper";

export const DayDone = 0;
export const DayUnable = 1;
export const CardGuideline = 3;
export const ScopeProgram = 1;

// The customer's guidelines. With a preview token (admin iframe) only the template is read and nothing is saved.
export class GuidelineApi {
  static base(): string {
    return `${Settings.HostName}/api/publiccustomerguidelines/customer/${CustomerHelper.getStoredCustomer()}`;
  }

  static list(): Promise<any> {
    return new CrudService().httpGet(this.base());
  }

  static detail(id: number | string, previewToken: string): Promise<any> {
    const url = previewToken
      ? `${Settings.HostName}/api/publiccustomerguidelines/preview/${id}?t=${encodeURIComponent(previewToken)}`
      : `${this.base()}/${id}`;
    return new CrudService().httpGet(url);
  }

  static record(id: number, date: string, status: number): Promise<any> {
    return new CrudService().httpPost(`${this.base()}/${id}/days`, { date: date, status: status });
  }

  static undo(id: number, date: string): Promise<any> {
    return new CrudService().httpDelete(`${this.base()}/${id}/days/${date}`);
  }

  // Civil days travel as yyyy-MM-dd; the API sends them at midnight.
  // Straight to today's session when there is one to do, so the customer does not go through the overview.
  static link(row: any, back: string = ""): string {
    const query: string[] = [];
    if (row.hasSessions && row.todayStatus === null) query.push("session=next");
    if (back) query.push("back=" + encodeURIComponent(back));
    return `/guidelines/${row.id}` + (query.length ? "?" + query.join("&") : "");
  }

  static day(input: string): string {
    return (input || "").substring(0, 10);
  }

  static addDays(day: string, n: number): string {
    const d = new Date(day + "T12:00:00");
    d.setDate(d.getDate() + n);
    return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
  }

  static mondayOf(day: string): string {
    const back = (new Date(day + "T12:00:00").getDay() + 6) % 7;
    return this.addDays(day, -back);
  }
}
